module.exports = {
      id: "default-card-image-usage",
      viewBox: "0 0 1024 683",
      url: "/" + "sprite-a402f8ffc4310bc2e096ed6c94b22ccb.svg#default-card-image",
      toString: function () {
        return this.url;
      }
    }